module.exports = __webpack_public_path__ + "static/ic_draw_f.5aaaac08.png";